<template>
  <div>

<loading-container :state="state" errormsg="Beim Laden der Anwendungen ist ein Fehler aufgetreten. Bitte probieren Sie es nochmals oder kontaktieren Sie den Help-Desk: help-desk@brz.gv.at">
  <div class="mb-5 d-block brz-aktiv">
    <div class="row">
      <div class="col-12">
        <p class="f-20" v-if="!changeable">{{ textStandard}}</p>
        <p class="f-20" v-else>{{ textEdit}}</p>
      </div>
      <div class="col-12 d-flex justify-content-end" v-if="changeable">
        <button class="btn btn-link mr-3" @click="cancelList()">Abbrechen</button>
        <button class="btn btn-primary btn-anwendungen" @click="saveList()">Änderungen speichern</button>
      </div>
      <div class="col-12 d-flex justify-content-end" v-else>
        <button class="btn btn-primary btn-anwendungen" @click="changechange">Anwendungsfavoriten bearbeiten</button>
      </div>
    </div>
  </div>

  <div class="mb-5 anwendungsliste d-block">
    <div class="row">
      <div class="col-12">

        <div v-if="!changeable">
          <ul class="list-group list-unstyled">
            <li class="list-group-item mb-0" v-for="item in list" :key="item.uri">
              <!-- debug code - original window open string if available -->
              <template v-html="getOriginalOpenWindowString(item)" />
              <!-- only open apps OCT and OCP in popup -->
              <template v-if="item.window && item.id && (item.id === 'OCT' || item.id === 'OCP')">
                <a href="#" @click.prevent="openWindow(item)" class="d-flex align-items-center fs-16" :title="getTooltip(item)" rel="noreferrer noopener">
                  <div>{{ item.displayName }}</div>
                  <div><i class="fas fa-external-link-alt ml-2 fs-12"></i><span class="sr-only">öffnen</span></div>
                </a>
              </template>
              <template v-else>
                <a :href="sanitizeUrl(item.uri)" class="d-flex align-items-center fs-16" :title="getTooltip(item)" target="_blank" rel="noreferrer noopener">
                  <div>{{ item.displayName }}</div>
                  <div><i class="fas fa-external-link-alt ml-2 fs-12"></i><span class="sr-only">öffnen</span></div>
                </a>
              </template>
            </li>
          </ul>
        </div>

        <div v-else>
        <draggable
          tag="ul"
          :list="list"
          class="list-group list-unstyled"
          handle=".handle"
          v-bind="dragOptions"
          @start="drag = true"
          @end="drag = false"
          item-key="name"
        >
          <template #item="{ element, index }">
            <li class="list-group-item mb-0">
              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center">
                  <i class="fas fa-grip-horizontal handle mr-3" aria-hidden="true"></i>

                  <div class="form-check mr-3">
                    <input class="form-check-input" type="checkbox" :checked="element.favorit" :id="index" @change="changeFavCheckbox(index)">
                    <label class="form-check-label" :for="index">
                      <span class="text">{{ element.displayName }} </span>
                      <span class=sr-only>als Favoriten einrichten</span>
                    </label>
                  </div>

                </div>
                <div class="d-flex">
                  <button v-if="index > 0" class="btn btn-arrow py-0 fs-12" @click="moveUp(index)"><i class="fas fa-long-arrow-alt-up"></i></button>
                  <button v-if="index < (list.length -1)" class="btn btn-arrow py-0 fs-12" @click="moveDown(index)"><i class="fas fa-long-arrow-alt-down"></i></button>
                </div>
              </div>
            </li>
          </template>
        </draggable>
        </div>

      </div>
    </div>
  </div>
</loading-container>

  </div>
</template>

<script lang="ts">
import draggable from "vuedraggable";
import { defineComponent } from 'vue'
import anwendungsService from '@/services/anwendungsService'
import { Anwendung } from '@/generated/openapi'
import LoadingMixin from '@/mixins/LoadingMixin'
import LoadingContainer from '@/components/structure/LoadingContainer.vue'
import CONFIG from '@/config/config'
import { sanitizeUrl } from '@braintree/sanitize-url'

export default defineComponent({
  name: "AnwendungsListe",
  display: "Anwendungsliste",
  instruction: "Drag using the handle icon",
  order: 5,
  components: {
    draggable,
    LoadingContainer
  },
  mixins: [
    LoadingMixin
  ],
  data() {
    return {
      changeable: false,
      list: [] as Anwendung[],
      drag: false,
      textStandard: CONFIG.anwendungslisteTextStandard,
      textEdit: CONFIG.anwendungslisteTextEdit,
      sanitizeUrl: sanitizeUrl
    };
  },
  computed: {
    draggingInfo(): string {
      return this.drag ? "under drag" : "";
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },

  },
  created() {
    this.getAnwendungenFromServer();
  },
  methods: {
    triggerFavoritenChanged() {
      this.$store.commit('triggerAnwendungslisteChanged')
    },
    changechange(){
      this.changeable = !this.changeable
    },
    swapArrayElements (arr: any, indexA: number, indexB: number) {
          const temp = arr[indexA];
          arr[indexA] = arr[indexB];
          arr[indexB] = temp;
        },
    moveUp(idx: number){
      if(idx !== 0){
        const idx_new = idx - 1;
        this.swapArrayElements(this.list, idx, idx_new);
      }
    },
    moveDown(idx: number){
      if(idx < (this.list.length-1)){
        const idx_new = idx + 1;
        this.swapArrayElements(this.list, idx, idx_new);
      }
    },
    saveList(){
      // eslint-disable-next-line
      const newArray = this.list.map(({displayName /* unused */, uri /* unused */, tooltip /* unused */, window /* unused */, ...keepAttrs}) => keepAttrs)

      anwendungsService.sortAnwendungen(newArray).then( () => {
        this.handleSuccess()
        this.changeable = false;
        }).catch(this.handleError)
        .finally(() => {
          this.triggerFavoritenChanged()
        })
    },
    cancelList(){
      this.getAnwendungenFromServer();
    this.changeable = false;
    },
    changeFavCheckbox(idx: number){
      this.list[idx].favorit = !this.list[idx].favorit;
    },
    getAnwendungenFromServer(){
      anwendungsService.getAlleAnwendungen().then(anwendungen => {
        this.list = anwendungen;
        this.handleSuccess()
      }).catch(this.handleError)
    },
    openWindow(item: Anwendung) {
      anwendungsService.openWindow(item)
    },
    getOriginalOpenWindowString(item: Anwendung) {
      // wanted format: width=-10,height=-30,left=0,top=0,location=no,menubar=no,resizable=yes,toolbar=yes,scrollbars=yes,status=yes,dependent=no,blurfunction=0
      let os = "<!-- "
      os += "width=" + item.window?.screenWidth
      os += ",height=" + item.window?.screenHeight
      os += ",left=" + item.window?.left
      os += ",top=" + item.window?.top
      os += ",location=" + item.window?.location
      os += ",menubar=" + item.window?.menubar
      os += ",resizable=" + item.window?.resizable
      os += ",toolbar=" + item.window?.toolbar
      os += ",scrollbars=" + item.window?.scrollbars
      os += ",status=" + item.window?.status
      os += ",dependent=" + item.window?.dependent
      os += ",blurfunction=" + item.window?.blurfunction
      os += " -->"
      return os
    },
    getTooltip(item: Anwendung) {
      if (item.tooltip) {
        return item.tooltip
      } else {
        return ((item.displayName || '') + ' in einem neuen Fenster öffnen')
      }
    }
/*     getAnwendungenFromServer(){

      this.list = [
    {
        "id": "AWU",
        "displayName": "Anwesenheitsübersicht",
        "uri": "https://proxy.portal.at/at.gv.brz.awue/",
        "favorit": false
    },
    {
        "id": "LEP",
        "displayName": "BRZ Lernportal",
        "uri": "https://www.brz-lernportal.at",
        "favorit": false
    },
    {
        "id": "BOP",
        "displayName": "BRZ-DMS (BRZ-Office)",
        "uri": "https://brzoffice.portal.at/livelink/llisapi.dll/app",
        "favorit": false
    },
    {
        "id": "BSP",
        "displayName": "BRZ SAP Portal",
        "uri": "https://brz2pj.portal.at/irj/portal",
        "favorit": true
    },
    {
        "id": "CFC",
        "displayName": "CONFLUENCE",
        "uri": "https://confluence.portal.at/",
        "favorit": true
    },
    {
        "id": "JRA",
        "displayName": "JIRA",
        "uri": "https://jira.portal.at/",
        "favorit": true
    },
    {
        "id": "BFX",
        "displayName": "BMF-Extranet",
        "uri": "https://extranetbmf.portal.at",
        "favorit": false
    },
    {
        "id": "ELP",
        "displayName": "BRZ E-Learning",
        "uri": "https://brzelearning.portal.at",
        "favorit": false
    },
    {
        "id": "SFP",
        "displayName": "BRZ Formularservice",
        "uri": "https://ls1.portal.at/at.gv.brz.formularservice-p/index.html",
        "favorit": false
    },
    {
        "id": "BTQ",
        "displayName": "BRZ-Intranet (QS)",
        "uri": "https://awp2.lfrz.at/stdportal-sp/portalverbund.gv.at/at.gv.brz.intranet.qs/login?entityID=https%3A%2F%2Fbrz.portal.at%2Fidp_metadata.xml",
        "favorit": false
    },
    {
        "id": "IND",
        "displayName": "Individuelle Administration",
        "uri": "https://resources.portal.at/appcall_registration/submenu/?menu=IND&owopt=1",
        "favorit": false
    },
    {
        "id": "KHO",
        "displayName": "Redaktionssystem LFRZ Magnolia K5",
        "uri": "https://ls1.portal.at/at.lfrz.cmsauthor5/",
        "favorit": false
    },
    {
        "id": "CNX",
        "displayName": "Portal Content Management",
        "uri": "https://cn.portal.at/Content.Node/",
        "favorit": false
    }
];

this.handleSuccess();

    }*/
  },

});
</script>

<style scoped>
@import 'assets/css/fontawesome.6.4.1.all.min.css';

.fs-12 {
  font-size: 0.75rem;
}

.fs-16 {
  font-size: 1rem;
}

.anwendungsliste .list-group-item {
    text-align: left;
    border-left: 0px solid transparent;
    border-right: 0px solid transparent;
    color: #252C31;
}
.list-group-item + .list-group-item {
    border-top-width: 0;
}
.list-group-item {
    position: relative;
    display: block;
    padding: 0.5rem 1rem;
    text-decoration: none;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);
}

.anwendungsliste .handle {
    float: left;
    padding-top: 8px;
    padding-bottom: 8px;
    cursor: move;
    color: #838A90;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
}

.form-check {
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5em;
    margin-bottom: 0.125rem;
}

.form-check-input:checked[type=checkbox] {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");
}
.form-check-input:checked {
    background-color: #286f9c;
    border-color: #286f9c;
}
.form-check-input[type=checkbox] {
    border-radius: 0.25em;
}
.form-check .form-check-input {
    float: left;
    margin-left: -1.5em;
    margin-top: 7px;
}
.form-check-input {
    width: 1em;
    height: 1em;
    margin-top: 0.25em;
    vertical-align: top;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: 1px solid rgba(0, 0, 0, 0.25);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
}
input, button, select, optgroup, textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}
</style>
